/** Completed stays selectable for already completed items; every new approval
 * must originate in Done and be made by a selected reviewer. Server rechecks it. */
export function canComplete(item: { approval_required: boolean; approver_ids: string[] }, status: string, userId?: string): boolean {
  return !item.approval_required || status === "completed" || (status === "done" && !!userId && item.approver_ids.includes(userId));
}
